/* kategorie aktywności */

import { PROD_VARIANT_CHOICES } from "../../components/Enumerators";

export enum ACTIVITY_CHOICES {
    ACTIVITY_NONE = PROD_VARIANT_CHOICES.PROD_VARIANT_NONE,
    ACTIVITY_WALK = PROD_VARIANT_CHOICES.PROD_VARIANT_WALK,
    ACTIVITY_RUN = PROD_VARIANT_CHOICES.PROD_VARIANT_RUN,
    ACTIVITY_RIDE = PROD_VARIANT_CHOICES.PROD_VARIANT_RIDE,
    ACTIVITY_IRON = PROD_VARIANT_CHOICES.PROD_VARIANT_IRON,
}

export enum TSHIRT_CHOICES {
    PROD_VARIANT_TSHIRT_W = PROD_VARIANT_CHOICES.PROD_VARIANT_TSHIRT_W,
    PROD_VARIANT_TSHIRT_M = PROD_VARIANT_CHOICES.PROD_VARIANT_TSHIRT_M,
}
